module.exports = function(fn) {
  return function() {
    return fn.apply(null, arguments);
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/arity-n/0.js
// module id = ./node_modules/arity-n/0.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons